import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

const publicRoutes = ['Home'];

router.beforeEach((to, _from, next) => {
    if (publicRoutes.includes(to.name) || store.state.userNbInfo.access_token) {
        next();
    } else {
        store.commit('setIntendedRoute', to.fullPath);
        next({ name: 'Home' });
    }
});

createApp(App).use(store).use(router).mount('#app')
